/**
 * Feature-scoped Deal detail section header.
 * Replaces nested page-level `.clients-header` gradient cards inside Deal sections.
 */
function DealWorkspaceSectionHeader({
  id,
  eyebrow,
  title,
  helper,
  privacyBadge = null,
  iconClassName = "fa-solid fa-lock",
  actions = null,
}) {
  return (
    <header className="deal-workspace-section-header">
      <div className="deal-workspace-section-header__main">
        <span
          className="deal-workspace-section-header__icon"
          aria-hidden="true"
        >
          <i className={iconClassName} />
        </span>
        <div className="deal-workspace-section-header__text">
          {eyebrow ? (
            <p className="deal-workspace-section-header__eyebrow">{eyebrow}</p>
          ) : null}
          <h2 id={id} className="deal-workspace-section-header__title">
            {title}
          </h2>
          {privacyBadge ? (
            <span className="deal-workspace-section-header__privacy">
              {privacyBadge}
            </span>
          ) : null}
          {helper ? (
            <p className="deal-workspace-section-header__helper">{helper}</p>
          ) : null}
        </div>
      </div>
      {actions ? (
        <div className="deal-workspace-section-header__actions">{actions}</div>
      ) : null}
    </header>
  );
}

export default DealWorkspaceSectionHeader;
